<button class="btn--no-outline focus-inset flex flex--center" (click)="toggleMenu($event)">
  <span [class.open]="isOpen" class="menu-icon" [class.menu-icon--white]="whiteIcon">
    <span class="is-vishidden">{{ (isOpen ? 'menu.close' : 'menu.open') | finLocalization }}</span>
    <fcom-icon class="menu icon-medium" name="menu-list"></fcom-icon>
    <fcom-icon class="chevron icon-medium" name="chevron-left"></fcom-icon>
  </span>
</button>
